import { openModal } from '@core/components/ModalStack';
import { PaybiltLinkModalProps } from './PaybiltLinkModal';

export async function openPaybiltLinkModal(props: PaybiltLinkModalProps) {
  const { PaybiltLinkModal } = await import('./PaybiltLinkModal');

  openModal(PaybiltLinkModal, props);
}
